(function () {
    var root = document.getElementById("ContactDrawer");
    if (!root) return;

    var panel = document.getElementById("contact-drawer-panel");
    var fab = root.querySelector("[data-contact-drawer-open]");
    var closeEls = root.querySelectorAll("[data-contact-drawer-close]");
    var backdrop = root.querySelector(".contact-drawer__backdrop");

    var scrollBlockHandler = null;

    function isInsidePanel(target) {
        return panel && target && panel.contains(target);
    }

    /* Block page scroll but keep the scrollbar visible (no overflow:hidden / position:fixed) */
    function blockPageScroll(e) {
        if (!root.classList.contains("is-open")) return;
        if (isInsidePanel(e.target)) return;
        e.preventDefault();
    }

    function blockScrollKeys(e) {
        if (!root.classList.contains("is-open")) return;
        if (isInsidePanel(e.target)) return;
        var keys = [" ", "PageUp", "PageDown", "Home", "End", "ArrowUp", "ArrowDown"];
        if (keys.indexOf(e.key) !== -1) e.preventDefault();
    }

    function lockScroll() {
        if (document.body.classList.contains("contact-drawer-open")) return;
        document.body.classList.add("contact-drawer-open");
        scrollBlockHandler = blockPageScroll;
        document.addEventListener("wheel", scrollBlockHandler, { passive: false });
        document.addEventListener("touchmove", scrollBlockHandler, { passive: false });
        document.addEventListener("keydown", blockScrollKeys);
    }

    function unlockScroll() {
        if (!document.body.classList.contains("contact-drawer-open")) return;
        document.body.classList.remove("contact-drawer-open");
        if (scrollBlockHandler) {
            document.removeEventListener("wheel", scrollBlockHandler);
            document.removeEventListener("touchmove", scrollBlockHandler);
            scrollBlockHandler = null;
        }
        document.removeEventListener("keydown", blockScrollKeys);
    }

    function openDrawer() {
        lockScroll();
        root.classList.add("is-open");
        root.setAttribute("aria-hidden", "false");
        if (fab) fab.setAttribute("aria-expanded", "true");
    }

    function closeDrawer() {
        root.classList.remove("is-open");
        root.setAttribute("aria-hidden", "true");
        if (fab) fab.setAttribute("aria-expanded", "false");
        unlockScroll();
    }

    if (fab) {
        fab.addEventListener("click", function (e) {
            e.stopPropagation();
            openDrawer();
        });
    }
    closeEls.forEach(function (el) {
        el.addEventListener("click", closeDrawer);
    });
    if (backdrop) backdrop.addEventListener("click", closeDrawer);

    document.addEventListener(
        "click",
        function (e) {
            if (!root.classList.contains("is-open")) return;
            if (panel && panel.contains(e.target)) return;
            if (fab && (fab === e.target || fab.contains(e.target))) return;
            closeDrawer();
        },
        true,
    );

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && root.classList.contains("is-open"))
            closeDrawer();
    });

    root.querySelectorAll('[data-helpcrunch-open="true"]').forEach(
        function (btn) {
            btn.addEventListener("click", function () {
                closeDrawer();
                if (typeof window.HelpCrunch === "function") {
                    try {
                        window.HelpCrunch("openChat");
                    } catch (err) {}
                }
            });
        },
    );

    var configEl = document.getElementById("contact-drawer-opening-hours");
    if (!configEl) return;

    var config;
    try {
        config = JSON.parse(configEl.textContent);
    } catch (err) {
        return;
    }

    function normalizeDayString(raw) {
        if (!raw || typeof raw !== "string") return "";
        return raw.trim().replace(/\u2013|\u2014/g, "-");
    }

    function parseTimeToMinutes(t) {
        var m = /^(\d{1,2}):(\d{2})$/.exec(String(t).trim());
        if (!m) return null;
        return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
    }

    function isOpenForDay(dayValue, nowMinutes) {
        var normalized = normalizeDayString(dayValue);
        if (!normalized || /^closed$/i.test(normalized)) return false;

        var parts = normalized.split("-");
        if (parts.length < 2) return false;

        var start = parseTimeToMinutes(parts[0]);
        var end = parseTimeToMinutes(parts[1]);
        if (start === null || end === null) return false;

        if (end <= start) {
            return nowMinutes >= start || nowMinutes < end;
        }
        return nowMinutes >= start && nowMinutes < end;
    }

    function isStoreOpen(schedule, timezone) {
        var tz = timezone || "Europe/Amsterdam";
        var formatter;

        try {
            formatter = new Intl.DateTimeFormat("en-US", {
                timeZone: tz,
                weekday: "long",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            });
        } catch (e) {
            formatter = new Intl.DateTimeFormat("en-US", {
                timeZone: "Europe/Amsterdam",
                weekday: "long",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            });
        }

        var weekday = "";
        var hour = 0;
        var minute = 0;

        formatter.formatToParts(new Date()).forEach(function (part) {
            if (part.type === "weekday") weekday = part.value.toLowerCase();
            if (part.type === "hour") hour = parseInt(part.value, 10);
            if (part.type === "minute") minute = parseInt(part.value, 10);
        });

        var nowMinutes = hour * 60 + minute;
        var daySchedule = schedule && schedule[weekday];
        return isOpenForDay(daySchedule, nowMinutes);
    }

    function updateOpeningHoursStatus() {
        var open = isStoreOpen(config.schedule, config.timezone);

        document
            .querySelectorAll("[data-opening-hours-item]")
            .forEach(function (item) {
                var dot = item.querySelector(
                    "[data-contact-drawer-status-dot]",
                );
                var textEl = item.querySelector(
                    "[data-contact-drawer-status-text]",
                );
                var onlineText = item.getAttribute("data-online-text") || "";
                var offlineText = item.getAttribute("data-offline-text") || "";

                if (dot) {
                    dot.classList.toggle(
                        "contact-drawer__status--active",
                        open,
                    );
                    dot.classList.toggle(
                        "contact-drawer__status--inactive",
                        !open,
                    );
                }
                if (textEl) {
                    textEl.textContent = open ? onlineText : offlineText;
                }
            });
    }

    updateOpeningHoursStatus();
    setInterval(updateOpeningHoursStatus, 60000);
})();
